import React from "react"
import { ThemeProvider } from "styled-components"

import useVideoTracking from "hooks/useVideoTracking"
import componentThemeExtension from "utils/componentThemeExtension"

import Share from "./share"
import {
  Wrapper,
  Content,
  VideoContainer,
  Metadata,
  Social,
  Year,
  Title,
  Speakers,
  Description,
  LeafIcon,
} from "./styles"

const RevitalizeVideo = ({ video }) => {
  const { trackVideoProgress } = useVideoTracking()
  const progressTracker = trackVideoProgress(video.videoId, `revitalize-video-${video.id}`)

  return (
    <ThemeProvider theme={componentThemeExtension(null)}>
      <Wrapper>
        <Content>
          <VideoContainer
            videoId={video.videoId}
            videoSignature={video.videoSignature}
            autoPlay
            floating
            onPercentViewed={progressTracker}
          />
          <Metadata>
            <Social>
              <Year>mbgrevitalize {new Date(video.airDate).getFullYear()}</Year>
              <Share video={video} />
            </Social>
            <Title>{video.title}</Title>
            {video.speakers && <Speakers>with {video.speakers.join(", ")}</Speakers>}
            <Description dangerouslySetInnerHTML={{ __html: video.description }} />
          </Metadata>
        </Content>
        <LeafIcon id="revitalize-leaf-icon" viewBox="0 0 151 776" />
      </Wrapper>
    </ThemeProvider>
  )
}

export default RevitalizeVideo
